import { render } from "./ActiveContractPage.vue?vue&type=template&id=20ab680c&scoped=true"
import script from "./ActiveContractPage.vue?vue&type=script&lang=js"
export * from "./ActiveContractPage.vue?vue&type=script&lang=js"

import "./ActiveContractPage.vue?vue&type=style&index=0&id=20ab680c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ab680c"]])

export default __exports__